import React from "react";
import "./Complete.scss";
import { Button, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import Helpers from "@utils/Helpers";

const Conplete: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const response = JSON.parse(decodeURIComponent(urlParams.get("response")!));
  const navigate = useNavigate();

  return (
    <div className="Complete">
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={7}>
          <div className="complete-form">
            <div className="title">We have received your order</div>
            <div className="subTitle">
              You will receive an email confirmation shortly
            </div>
            <div className="orderPlaced">
              Order Placed: {Helpers.formatDateTime(response.order.create_date)}
            </div>
            <div className="orderId">
              Order ID: <span>#{response.order.order_id}</span>
            </div>
            <div className="product-list">
              <ul>
                {response.order_items.map((item: any, index: number) => {
                  const producerName = item.producer_name;
                  return item.product_items.map((ite: any, idx: number) => {
                    return (
                      <li key={idx}>
                        {ite.product_type} will be shipped to you by{" "}
                        {producerName}
                      </li>
                    );
                  });
                })}
              </ul>
            </div>
            <div className="estimate">
              Estimated Delivery: <span>Jan 8th, 2025 - Jan 10th, 2025</span>
            </div>
            <div className="controls">
              <Button
                className="order-btn"
                onClick={() => {
                  navigate("/transaction");
                }}
              >
                Review Order
              </Button>
              <Button
                className="continue-btn"
                onClick={() => {
                  navigate("/products");
                }}
              >
                Continue Exploring
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Conplete;
